// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import type ConversationResponseShape from "../contract/ConversationResponseShape";

export default function conversationResponseShape(data: ConversationResponseShape): ConversationResponseShape {
    const result: ConversationResponseShape = {
        __type: "ConversationResponseShape:#Exchange",
        ...data,
    };
    
    return result;
}
